import ApiService from "@/core/services/ApiService";
import { Actions } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
import axios from "axios";

@Module
export default class ContractModule extends VuexModule {
  @Action
  async [Actions.GET_CONTRACT](contract) {
    try {
      delete axios.defaults.headers.common["Authorization"];
      const currentLang = window.localStorage.getItem("lang")
        ? window.localStorage.getItem("lang")
        : "en";
      const response = await ApiService.get(
        `contract/${contract}/${currentLang}`
      );
      ApiService.setHeader();
      return Promise.resolve(response);
    } catch (error) {
      ApiService.setHeader();
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }
}
